import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useQuery } from '@tanstack/react-query'
import { QueryKey } from '../../domain/enums/query-key'
import { GetSubscription } from '../../usecases/get-subscription'

export const useGetSubscription = (id: string) => {
  const container = useContainer()

  return useQuery([QueryKey.getSubscription, id], () => new GetSubscription(container.get(HttpClient)).execute(id), {
    refetchOnWindowFocus: false,
    retry: false,
    enabled: !!id,
  })
}
